<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="p2_pofinishprodcomp_keyno" [ttModel]="edit.p2_pofinishprodcomp_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="edit.prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="prodsize_keyno" [ttModel]="edit.prodsize_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="prodchoice_keyno" [ttModel]="edit.prodchoice_keyno" ttReadonly></tt-input>
        <tt-input-number ttLabel="calc_qty" [ttModel]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_picked" [(ttModel)]="edit.quantity_picked" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
